import Splide from '@splidejs/splide';
import 'fslightbox';

(() => {
    const blocks = document.querySelectorAll('[data-anchor-images-slider]');

    const options = {
        mediaQuery: 'min',
        type: 'loop',
        lazyLoad: 'nearby',
        preloadPages: 0,
        height: '208px',
        autoWidth: true,
        gap: '8px',
        arrows: false,
        breakpoints: {
            640: {
                perPage: 3,
                preloadPages: 1,
                height: 'auto',
                autoWidth: false,
                gap: '12px',
                arrows: false,
            },
            768: {
                perPage: 4,
                preloadPages: 1,
                gap: '20px',
            },
        },
    };

    for (let block of blocks) {
        const main = new Splide(block?.querySelector('.splide-images'), options);
        main.mount();
    }
})();
